module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_influences_black.c3e9c8f7.png";